
const SpecialPrograms = () => {
  const programs = [
    {
      title: 'Holiday Camps',
      description: 'Intensive training camps during school holidays',
      schedule: 'Summer: July 15-26, Winter: Dec 23-30',
      duration: '9:00 AM - 3:00 PM',
      price: '$299/week',
      features: ['All-day training', 'Lunch included', 'Guest coaches', 'Tournament play'],
      image: 'https://public.readdy.ai/ai/img_res/eb9ecd7bbb500e47604b332020d168c8.jpg'
    },
    {
      title: 'Private Coaching',
      description: 'One-on-one personalized training sessions',
      schedule: 'Available 7 days a week',
      duration: '60 or 90 minutes',
      price: '$85/hour',
      features: ['Customized training', 'Flexible scheduling', 'Video analysis', 'Progress tracking'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20coach%20providing%20one-on-one%20private%20training%20to%20a%20young%20player%20with%20personalized%20attention%20and%20specialized%20equipment%20on%20a%20well-maintained%20training%20field&width=400&height=250&seq=private-coaching&orientation=landscape'
    },
    {
      title: 'Goalkeeper Training',
      description: 'Specialized training for aspiring goalkeepers',
      schedule: 'Saturdays 2:30 PM - 4:00 PM',
      duration: '90 minutes',
      price: '$45/session',
      features: ['Specialized equipment', 'Expert GK coach', 'Shot-stopping drills', 'Distribution training'],
      image: 'https://readdy.ai/api/search-image?query=Young%20goalkeeper%20in%20training%20with%20specialized%20equipment%20and%20professional%20coaching%20showing%20diving%20saves%20and%20ball%20handling%20techniques%20on%20a%20soccer%20field%20with%20goal%20posts&width=400&height=250&seq=goalkeeper-training&orientation=landscape'
    },
    {
      title: 'Girls Only Sessions',
      description: 'Empowering female players in a supportive environment',
      schedule: 'Sundays 2:45 PM - 4:00 PM',
      duration: '75 minutes',
      price: '$35/session',
      features: ['Female coaches', 'Confidence building', 'Technical focus', 'Leadership skills'],
      image: 'https://readdy.ai/api/search-image?query=Confident%20young%20girls%20playing%20soccer%20together%20in%20a%20supportive%20training%20environment%20with%20female%20coaches%20showing%20teamwork%20and%20skill%20development%20in%20an%20empowering%20atmosphere&width=400&height=250&seq=girls-sessions&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Special Programs</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Beyond our regular sessions, we offer specialized programs designed to meet specific training needs and goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {programs.map((program, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img 
                src={program.image} 
                alt={program.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{program.title}</h3>
                <p className="text-gray-600 mb-4">{program.description}</p>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center space-x-3">
                    <i className="ri-calendar-line text-blue-600 w-5 h-5 flex items-center justify-center"></i>
                    <span className="text-gray-700">{program.schedule}</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-time-line text-blue-600 w-5 h-5 flex items-center justify-center"></i>
                    <span className="text-gray-700">{program.duration}</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-money-dollar-circle-line text-green-600 w-5 h-5 flex items-center justify-center"></i>
                    <span className="text-gray-700 font-semibold">{program.price}</span>
                  </div>
                </div>

                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">Program Highlights</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {program.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center space-x-2">
                        <i className="ri-check-line text-green-600 text-sm"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-blue-700 hover:to-purple-700 transition-all whitespace-nowrap cursor-pointer">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Can't Find the Right Time?</h3>
            <p className="text-gray-600 mb-6">
              We understand that every family has different schedules. Contact us to discuss alternative arrangements or to be notified when new session times become available.
            </p>
            <button className="bg-gradient-to-r from-green-600 to-blue-600 text-white py-3 px-8 rounded-lg font-semibold hover:from-green-700 hover:to-blue-700 transition-all whitespace-nowrap cursor-pointer">
              Contact Us About Scheduling
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecialPrograms;
